module.exports = __webpack_public_path__ + "img/settle-inbounds.7e78e1e8.png";